module.exports = __webpack_public_path__ + "media/images/sp/stores/hamamatsu/hamamatsu_concept_02-87dca5b2621b888b743d8acb9e7d1392.jpg";